import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useUpdateDocumentTitle, useYoutubeAnalyticsCountriesCategoriesOptions } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { TrendingYoutubePosts } from './TrendingYoutubePosts';

export const TrendingPosts = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.Trending Posts', appHeader: 'appHeader.Trending Posts' });
  const { loading, allCountryOptions, allCategoryOptions } = useYoutubeAnalyticsCountriesCategoriesOptions();

  return (
    <div>
      <Header />
      <RenderDataWithFallback loading={loading}>
        <TrendingYoutubePosts allCountryOptions={allCountryOptions} allCategoryOptions={allCategoryOptions} />
      </RenderDataWithFallback>
    </div>
  );
};
